import { trackArticleWrite } from "@core/FileStructue/Article/pendingArticleWrite";
import type { ClientArticleProps } from "@core/SitePresenter/SitePresenter";
import type ApiUrlCreator from "@core-ui/ApiServices/ApiUrlCreator";
import FetchService from "@core-ui/ApiServices/FetchService";
import MimeTypes from "@core-ui/ApiServices/Types/MimeTypes";
import type { Property, PropertyValue } from "@ext/properties/models";

/** Nobody awaits the write, so a read of the article waits for it instead; see pendingArticleWrite.ts. */
export const saveArticleProps = (
	apiUrlCreator: ApiUrlCreator,
	props: ClientArticleProps | (Omit<ClientArticleProps, "properties"> & { properties: Property[] | PropertyValue[] }),
) =>
	trackArticleWrite(apiUrlCreator.catalogName, props.ref.path, () =>
		FetchService.fetch(apiUrlCreator.updateItemProps(), JSON.stringify(props), MimeTypes.json),
	);

/** One property of any article in the catalog, as a view moves a card; the same rule applies. */
export const saveArticleProperty = (
	apiUrlCreator: ApiUrlCreator,
	articlePath: string,
	property: string,
	value: string,
	isDelete?: boolean,
) =>
	trackArticleWrite(apiUrlCreator.catalogName, articlePath, () =>
		FetchService.fetch(apiUrlCreator.updateArticleProperty(articlePath, property, value, isDelete?.toString())),
	);

/** A property moved from one value to another, as dropping an article into a group does; the same rule applies. */
export const moveArticleProperty = (
	apiUrlCreator: ApiUrlCreator,
	articlePath: string,
	property: string,
	from: string | null,
	to: string | null,
) =>
	trackArticleWrite(apiUrlCreator.catalogName, articlePath, () =>
		FetchService.fetch(
			apiUrlCreator.moveArticleProperty(articlePath, property),
			JSON.stringify({ from, to }),
			MimeTypes.json,
		),
	);
